const publicSales = require('./src/public_sales');
const privateOfferDates = require('./src/private_offer_dates');
const s3 = require('./src/s3');
const shopperTiers = require('./src/shopper_tiers');
const shopperEligibility = require('./src/shopper_eligibility');
const opportunities = require('./src/opportunities');
const receiptDomains = require('./src/receipt_domains');
const receiptSources = require('./src/receipt_sources');
const affiliateRates = require('./src/affiliate_rates');
const registration = require('./src/registration');
const agentToolLifecycleEvents = require('./src/agent_tool_lifecycle_events');
const agentChat = require('./src/agent_chat');
const spotlights = require('./src/spotlights');
const spotlightActivity = require('./src/spotlight_activity');
const productPrice = require('./src/product_price');
const brandMemberships = require('./src/brand_memberships');
const validation = require('./src/validation');
const pins = require('./src/pins');
const linkCreationSources = require('./src/link_creation_sources');
const linkPrograms = require('./src/link_programs');
const shareLinkSources = require('./src/share_link_sources');
const smartDm = require('./src/smart_dm');
const shopifyCatalogReconciliation = require('./src/shopify_catalog_reconciliation');
const webinars = require('./src/webinars');
const appDownloads = require('./src/app_downloads');
const mobileVersion = require('./src/mobile_version');
const userBans = require('./src/user_bans');
const brandHealth = require('./src/brand_health');
const splitBucket = require('./src/split_bucket');
const giftingAlertStyles = require('./src/gifting_alert_styles');
const notificationSettings = require('./src/notification_settings');
const userFeatureFlags = require('./src/user_feature_flags');
const notificationCopy = require('./src/notification_copy');
const klaviyoFlowUrls = require('./src/klaviyo_flow_urls');
const offerCodeUrls = require('./src/offer_code_urls');
const subscriptionModules = require('./src/subscription_modules');
const brandBudget = require('./src/brand_budget');
const chatMessageAllowances = require('./src/chat_message_allowances');
const chatText = require('./src/chat_text');
const subscriptionCommitment = require('./src/subscription_commitment');
const userNames = require('./src/user_names');
const shopifyOrderTags = require('./src/shopify_order_tags');
const attributionParams = require('./src/attribution_params');
const waitlist = require('./src/waitlist');
const disclaimerNotes = require('./src/disclaimer_notes');
const commissionDisclaimerDisplay = require('./src/commission_disclaimer_display');
const payoutCsv = require('./src/payout_csv');
const giftingConfiguration = require('./src/gifting_configuration');
const requestDeadlines = require('./src/request_deadlines');
const oauthApplications = require('./src/oauth_applications');

module.exports = {
  giftingConfiguration,
  requestDeadlines,
  privateOfferDates,
  s3,
  brandHealth,
  shopperTiers,
  shopperEligibility,
  opportunities,
  receiptDomains,
  receiptSources,
  affiliateRates,
  registration,
  agentToolLifecycleEvents,
  agentChat,
  spotlights,
  spotlightActivity,
  productPrice,
  brandMemberships,
  validation,
  pins,
  linkCreationSources,
  linkPrograms,
  shareLinkSources,
  smartDm,
  shopifyCatalogReconciliation,
  webinars,
  appDownloads,
  mobileVersion,
  userBans,
  splitBucket,
  giftingAlertStyles,
  notificationSettings,
  userFeatureFlags,
  notificationCopy,
  klaviyoFlowUrls,
  offerCodeUrls,
  subscriptionModules,
  brandBudget,
  publicSales,
  chatMessageAllowances,
  chatText,
  subscriptionCommitment,
  userNames,
  shopifyOrderTags,
  attributionParams,
  waitlist,
  disclaimerNotes,
  commissionDisclaimerDisplay,
  payoutCsv,
  oauthApplications
};
